import Container from 'components/common/Container';
import PageTemplate from 'components/template/PageTemplate';
import { termsContent } from 'data/terms';

const Privacy = () => {


    return (
        <PageTemplate overLay={false}>
            <Container>
                <h2 className='py-10 text-3xl text-center'>PulseOnShip 이용약관 동의</h2>
                <div className="text-left" dangerouslySetInnerHTML={{ __html: termsContent[0] }}></div>
                <h2 className='py-10 text-3xl text-center'>개인처리정보방침</h2>
                <div className="text-left" dangerouslySetInnerHTML={{ __html: termsContent[1] }}></div>
            </Container>
        </PageTemplate>
    );
}

export default Privacy;